import { createSignal } from '@verclam/pulsar';

/** `true` while the creation panel is open. */
const createSubjectSidebarSignal = createSignal<boolean>(false);

export const openCreateSubjectSidebar = (): void => {
	createSubjectSidebarSignal.value = true;
};

export const closeCreateSubjectSidebar = (): void => {
	createSubjectSidebarSignal.value = false;
};

export default createSubjectSidebarSignal;
